import { useState } from 'react';
import { TaskPage } from '../../../components/workbook/TaskPage';
import { TextInput, TextArea, Checkbox } from '../../../components/workbook/forms';
import { Callout } from '../../../components/workbook/Callout';

export default function FacilitationRailsArrangePage() {
  const [whyOneBeatTwo, setWhyOneBeatTwo] = useState('');
  const [hasQuickWin, setHasQuickWin] = useState(false);
  const [hasBigBet, setHasBigBet] = useState(false);
  const [hasSustaining, setHasSustaining] = useState(false);
  const [hasLearning, setHasLearning] = useState(false);
  const [riskiestDependency, setRiskiestDependency] = useState('');
  const [cutCount, setCutCount] = useState('');
  const [rationaleRecorded, setRationaleRecorded] = useState(false);

  return (
    <TaskPage
      phase="arrange"
      title="Facilitation Rails & Retrieval Check"
      pageNumber={8}
      instruction="Quick recall to strengthen memory and follow-through. Suggested timing: 60–90 min total (A1 10 · A2 15 · A3 10 · A4 10 · A5 10 · A6 10–20 · A7 10–15 · Close 5)"
      whyItMatters="Retrieval at the end cements choices; repeat briefly in later modules for spacing benefits."
      coachRail={{
        timing: "3-5 minutes",
        tips: "Opener: 'which theme surprised you most?' Closer: 'one item I'm willing to cut—and why.'",
        debrief: "We cut __ items and recorded the rationale ☐"
      }}
    >
      <div className="space-y-6">
        <div className="bg-[var(--surface)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-pri)] mb-4">Quick Recall</h3>
          <div className="space-y-4">
            <TextArea
              label="I can explain why #1 beat #2"
              value={whyOneBeatTwo}
              onChange={(e) => setWhyOneBeatTwo(e.target.value)}
              placeholder="Why did the top item beat the second?"
              rows={3}
            />
            <div className="bg-[var(--slate-dim)] border border-[var(--slate)] p-4">
              <h4 className="text-sm font-semibold text-[var(--text-sec)] mb-3">Our portfolio includes:</h4>
              <div className="space-y-2">
                <label className="flex items-center gap-3 cursor-pointer">
                  <Checkbox
                    checked={hasQuickWin}
                    onChange={(e) => setHasQuickWin(e.target.checked)}
                    label="Quick win"
                  />
                </label>
                <label className="flex items-center gap-3 cursor-pointer">
                  <Checkbox
                    checked={hasBigBet}
                    onChange={(e) => setHasBigBet(e.target.checked)}
                    label="Big bet"
                  />
                </label>
                <label className="flex items-center gap-3 cursor-pointer">
                  <Checkbox
                    checked={hasSustaining}
                    onChange={(e) => setHasSustaining(e.target.checked)}
                    label="Sustaining"
                  />
                </label>
                <label className="flex items-center gap-3 cursor-pointer">
                  <Checkbox
                    checked={hasLearning}
                    onChange={(e) => setHasLearning(e.target.checked)}
                    label="Learning"
                  />
                </label>
              </div>
            </div>
            <TextInput
              label="The riskiest dependency is"
              value={riskiestDependency}
              onChange={(e) => setRiskiestDependency(e.target.value)}
              placeholder="What dependency concerns you most?"
            />
            <div className="flex items-center gap-4">
              <TextInput
                label="We cut __ items"
                value={cutCount}
                onChange={(e) => setCutCount(e.target.value)}
                placeholder="How many?"
                className="flex-1"
              />
              <label className="flex items-center gap-3 cursor-pointer mt-6">
                <Checkbox
                  checked={rationaleRecorded}
                  onChange={(e) => setRationaleRecorded(e.target.checked)}
                  label="and recorded the rationale"
                />
              </label>
            </div>
          </div>
        </div>

        <div className="bg-[var(--slate-dim)] border border-[var(--slate)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-sec)] mb-4">Facilitation Notes</h3>
          <div className="space-y-2 text-sm text-[var(--text-sec)]">
            <p><strong>Opener:</strong> "which theme surprised you most?"</p>
            <p><strong>Closer:</strong> "one item I'm willing to cut—and why."</p>
            <p className="mt-4"><strong>Suggested timing:</strong> 60–90 min total</p>
            <ul className="list-disc list-inside ml-4 mt-2">
              <li>A1: 10 min</li>
              <li>A2: 15 min</li>
              <li>A3: 10 min</li>
              <li>A4: 10 min</li>
              <li>A5: 10 min</li>
              <li>A6: 10–20 min</li>
              <li>A7: 10–15 min</li>
              <li>Close: 5 min</li>
            </ul>
          </div>
        </div>

        <Callout type="tip" phase="arrange">
          <p className="text-sm">Retrieval at the end cements choices. Repeat briefly in later modules for spacing benefits.</p>
        </Callout>
      </div>
    </TaskPage>
  );
}






